<template>
  <div class="nine_field_resume" v-show="showFlag || showOverlayFlag">
    <header>
      <img :src="bannerUrl" alt="" width="100%" />
      <img :src="bannerUrl" alt="" width="100%" />
      <div class="nine_field_resume_title">简历填写</div>
    </header>
    <div class="nine_field_resume_content">
      <div class="nine_field_resume_container">
        <van-field
          :class="{
            input_is_edit: nameIsEdit,
            input_not_content: !nineField.name,
            input_is_valid_error: error.name,
          }"
          required
          v-model="nineField.name"
          @blur="nameBlur"
          @focus="nameFocus"
          label="姓名"
          placeholder="请填写"
        />
        <div class="sex_content" :class="{ input_is_valid_error: error.sexType, }">
          <div class="sex_container">
            <div
              class="sex_bth"
              :class="{ sex_checked_btn: nineField.sexType === 1 }"
              @click="selectSexType(1)"
            >
              男
            </div>
            <div
              class="sex_bth"
              :class="{ sex_checked_btn: nineField.sexType === 2 }"
              @click="selectSexType(2)"
            >
              女
            </div>
          </div>
        </div>
        <van-field
          :class="{
            input_is_valid_error: error.birthday,
          }"
          required
          v-model="nineField.birthday"
          right-icon="arrow"
          label="出生日期"
          readonly
          clearable
          placeholder="请选择"
          @click="showBirthdayTimePopup = true"
        />
        <van-field
          :class="{
            input_is_valid_error: error.cityId,
          }"
          required
          v-model="nineField.city"
          right-icon="arrow"
          label="现居住城市"
          readonly
          placeholder="请选择"
          @click="cityShow = true"
        />
        <van-field
          :class="{
            input_is_valid_error: error.education,
          }"
          required
          v-model="nineField.education"
          right-icon="arrow"
          label="最高学历"
          readonly
          placeholder="请选择"
          @click="educationShow = true"
        />
        <van-field
          :class="{
            input_is_valid_error: error.schoolName,
          }"
          required
          ref="schoolName"
          v-model="nineField.schoolName"
          right-icon="arrow"
          @blur="schoolNameBlur"
          @input="inputSchool"
          label="学校名称"
          placeholder="请选择"
          readonly
          @click="handleSelectSchool"
        />
        <!-- <ul class="filter-list-cls" v-show="isShowSchoolList">
          <li v-for="item in filterSchoolList" :key="item.schoolId" @click="schoolSelected(item)">
            {{ item.schoolName }}
          </li>
        </ul> -->
        <van-field
          :class="{
            input_is_edit: majorNameIsEdit,
            input_not_content: !nineField.majorName,
            input_is_valid_error: error.majorName,
          }"
          class="field_edit"
          required
          ref="majorName"
          v-model="nineField.majorName"
          @blur="majorNameBlur"
          @focus="majorNameFocus"
          label="所学专业"
          placeholder="请填写"
          :right-icon="clearIcon"
          @click-right-icon="nineField.majorName = ''"
        />
        <div class="van-cell van-field school_time_cell">
          <div class="van-cell__title van-field__label">
            <span><span class="label_required">*</span>在校时间</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body time_container">
              <input
                v-model="nineField.startDate"
                type="text"
                class="van-field__control time_start"
                :class="{ time_start_short: nineField.startDate, input_is_valid_error: error.startDate, }"
                readonly
                placeholder="请选择开始时间"
                @click="selectDate('start')"
              />
              <span class="time_line"></span>
              <input
                :class="{
                  input_is_valid_error: error.endDate,
                }"
                v-model="nineField.endDate"
                type="text"
                class="van-field__control time_end"
                readonly
                placeholder="请选择结束时间"
                @click="selectDate('end')"
              />
              <!-- <div class="van-field__right-icon school_date_icon"></div> -->
            </div>
          </div>
        </div>
        <van-popup v-model="showBirthdayTimePopup" position="bottom" round>
          <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            title="请选择出生日期"
            :minDate="minDate"
            :maxDate="maxDate"
            @confirm="confirmBirthday"
            @cancel="
              () => {
                this.showBirthdayTimePopup = false
              }
            "
          />
        </van-popup>
        <van-popup v-model="showSchoolTimePopup" position="bottom" round>
          <van-datetime-picker
            v-model="schoolDate"
            type="year-month"
            :title="schoolTimeTitle"
            :minDate="minDate"
            @confirm="confirmSchoolTime"
            @cancel="handleSchoolTimeCancel"
          />
        </van-popup>
        <van-popup v-model="cityShow" position="bottom" round>
          <div class="header-opt-area">
            <span class="cancle-btn" @click="cancelPopup">取消</span>
            <span class="opt-content">请选择现居住城市</span>
            <span class="save-btn" @click="savePopup">确定</span>
          </div>
          <van-tree-select
            :items="areaItems"
            :active-id.sync="activeId"
            :main-active-index.sync="activeIndex"
            @click-item="cityChange"
          />
        </van-popup>
        <van-popup v-model="educationShow" position="bottom" round>
          <van-picker
            :default-index="currentEducationIndex"
            show-toolbar
            title="请选择最高学历"
            :columns="educationData"
            value-key="value"
            @confirm="confirmEducation"
            @cancel="
              () => {
                this.educationShow = false
              }
            "
          />
        </van-popup>
        <van-popup v-model="isShowSchoolList" position="bottom" round class="popup_school">
          <div class="header-opt-area">
            <span class="cancle-btn" @click="isShowSchoolList = false">取消</span>
            <span class="opt-content">学校名称</span>
            <span class="save-btn" @click="confirmSchoolName">确定</span>
          </div>
          <div class="popup_school_content">
            <van-search
              v-model="searchSchoolText"
              shape="round"
              placeholder="请输入学校名称"
              @input="inputSchool"
              :left-icon="require('./images/search.png')"
              :clearable="false"
            />
            <ul>
              <li
                v-for="item in filterSchoolList"
                :key="item.schoolId"
                @click="schoolSelected(item)"
              >
                <span :class="{ school_name_selected: schoolName === item.schoolName }">{{
                  item.schoolName
                }}</span>
                <i class="school_selected" v-if="schoolName === item.schoolName"></i>
              </li>
            </ul>
          </div>
        </van-popup>
        <van-field
          :class="{
            input_is_edit: emailIsEdit,
            input_not_content: !nineField.email,
            input_is_valid_error: error.email,
          }"
          class="field_edit"
          required
          v-model="nineField.email"
          v-show="showEmailField === 1"
          @focus="emailFocus"
          @blur="emailBlur"
          label="邮箱"
          placeholder="请填写"
          :right-icon="clearIcon"
          @click-right-icon="nineField.email = ''"
        />
      </div>
      <footer>
          <!-- :class="{ submit_btn_allow: submitFlag }" -->
        <van-button
          class="submit_btn"
          :class="{ submit_btn_allow: true }"
          type="info"
          @click="submit"
          >确认{{ scene }}</van-button
        >
      </footer>
    </div>
    <van-popup class="no-disturb" v-model="noDisturbShow" position="bottom">
      <div class="no-disturb-reminder">向您推荐优质职位消息</div>
      <div class="no-disturb-container">
        <van-button class="button-refuse" type="info" round @click="handleRefuse">拒绝</van-button>
        <van-button class="" type="info" round @click="handleAllow">允许</van-button>
      </div>
    </van-popup>
    <van-overlay
      z-index="100"
      duration="0"
      class-name="overlay_overseas"
      :show="showOverlay"
      @click="showOverlay = false"
    >
      <div class="wrapper" @click.stop>
        <div class="content">
          <div class="container">
            <div class="overlay_bg" :class="{ 'overlay_bg_sign_in': scene === '签到' }"></div>
            <div class="overlay_title">{{ overlayTitle }}</div>
          </div>
          <div class="overlay_confirm" @click="confirmSign">确定</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay
      z-index="10000"
      class-name="overlay_tip"
      :show="showOverlayTip"
      @click="showOverlayTip = false"
    >
      <div class="wrapper">
        <div class="content">{{ overlayTip }}</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { dateFormat } from '@/utils/dateFormat'
import {
  userSubmit,
  getProvinceList,
  getEducation,
  getSchoolList,
  userOpen,
  hideUserResume,
} from '@/api'
export default {
  data() {
    const date = new Date()
    let year = date.getFullYear()
    let maxDate = new Date(date.setYear(year - 16))
    let defaultBirthday = new Date(date.setYear(year - 21))
    let defaultSchoolDate = new Date(date.setYear(year - 3))
    return {
      minDate: new Date(1950, 0, 1),
      maxDate: maxDate,
      currentDate: defaultBirthday,
      currentEducationIndex: 0,
      showSchoolTimePopup: false,
      showBirthdayTimePopup: false,
      nineField: {
        activityShareId: '',
        name: '',
        sexType: 1,
        birthday: '',
        city: '',
        cityId: '',
        education: '',
        eduLevel: '',
        schoolName: null,
        majorName: null,
        startDate: null,
        endDate: null,
        email: '',
        countryId: '', // 国外传cityId,国内不传
      },
      cityShow: false,
      areaItems: [],
      activeId: 0,
      activeIndex: 0,
      schoolTimeTitle: '请选择开始时间',
      schoolDate: defaultSchoolDate,
      defaultStart: 18,
      defaultEnd: 4,
      schoolTimeType: 'start',
      educationData: [],
      educationShow: false,
      submitFlag: false,
      showFlag: false,
      bannerUrl: '',
      showEmailField: 2, // 1显示，2不显示
      noDisturbShow: false,
      redirectUrl: '', // 提交成功后落地页
      activityId: '', // url中没有activityId时从userOpen取
      isShowSchoolList: false,
      filterSchoolList: [],
      schoolName: '', // 选择学校时临时储存
      showOverlay: false,
      showOverlayFlag: false, // 进页面判断时如果已提交简历，让页面show
      overlayTitle: '',
      scene: '',
      searchSchoolText: '',
      majorNameIsEdit: false, // 专业正在编辑
      emailIsEdit: false, // 邮箱正在编辑
      nameIsEdit: false,
      clearIcon: require('./images/clear.png'),
      overlayTip: '', // 校验提示
      showOverlayTip: false,
      error: {
        name: false,
        sexType: false,
        birthday: false,
        cityId: false,
        education: false,
        eduLevel: false,
        schoolName: false,
        majorName: false,
        startDate: false,
        endDate: false,
        email: false,
      },
    }
  },
  async created() {
    window.pageYoffset = 1
    document.documentElement.scrollTop = 1
    document.body.scrollTop = 1
    const scene = this.$route.query.scene
    if (scene) {
      if (scene === 'SIGN_UP') {
        this.scene = '报名'
      } else if (scene === 'SIGN_IN') {
        this.scene = '签到'
      }
    }
    await this.loadEducation()
    await this.loadProvinceList()
    await this.userOpen()
  },
  mounted() {
    this.searchSchoolList = this.debounce(this.searchSchoolList)
  },
  watch: {
    nineField: {
      handler() {
        const keys = Object.keys(this.nineField)
        this.submitFlag = keys.every(ele => this.checkIptNoTip(ele))
      },
      deep: true,
    },
  },
  methods: {
    confirmSign() {
      location.href = this.redirectUrl
    },
    waitOverlay(redirectUrl, type) {
      this.overlayTitle = `${this.scene}成功！`
      if (type === 'success') {
        this.overlayTitle = `已${this.scene}`
      }
      this.showOverlay = true
      this.showOverlayFlag = true
      this.redirectUrl = redirectUrl
    },
    inputSchool(val) {
      if (val) {
        this.searchSchoolList(val)
      }
    },
    schoolSelected(val) {
      this.schoolName = val.schoolName
    },
    debounce(fn) {
      let timeout = null
      return function() {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          fn.apply(this, arguments)
        }, 500)
      }
    },
    async searchSchoolList(keyword) {
      let data = await getSchoolList({ keyword })
      if (data.status === 200) {
        let datas = data.data || []
        let resData = datas.map(item => {
          return {
            schoolId: item.numberKey,
            schoolName: item.value,
          }
        })
        this.filterSchoolList = resData
        if (resData.length > 0) {
          this.isShowSchoolList = true
        }
      }
    },
    schoolNameFormatter(value) {
      return value.replace(
        /(.*[0-9]{6,}.*)|(^[^0-9A-Za-z\(\)\（\）\u4E00-\u9FA5].*)|(^[0-9]*$)|(^[0-9][^A-Za-z\u4E00-\u9FA5]*[^0-9A-Za-z\u4E00-\u9FA5][^A-Za-z\u4E00-\u9FA5]*$)|(^[^0-9A-Za-z\u4E00-\u9FA5][^A-Za-z\u4E00-\u9FA5]*[0-9][^A-Za-z\u4E00-\u9FA5]*$)|(^[^A-Za-z\u4E00-\u9FA5]+$)/g,
        '',
      )
    },
    majorNameFormatter(value) {
      return value.replace(
        /(^[0-9]*$)|(^[^0-9A-Za-z\u4E00-\u9FA5]+$)|(^[0-9][^A-Za-z\u4E00-\u9FA5]*[^0-9A-Za-z\u4E00-\u9FA5][^A-Za-z\u4E00-\u9FA5]*$)|(^[^0-9A-Za-z\u4E00-\u9FA5][^A-Za-z\u4E00-\u9FA5]*[0-9][^A-Za-z\u4E00-\u9FA5]*$)/g,
        '',
      )
    },
    nameBlur(event) {
      event.target.value = event.target.value.replace(/\n/g, '')
      let value = event.target.value
      if (value) {
        this.blurFn(value.length, 2, 20, '姓名')
      }
      this.nameIsEdit = false
    },
    nameFocus() {
      this.nameIsEdit = true
    },
    schoolNameBlur(event) {
      event.target.value = event.target.value.replace(/\n/g, '')
      let value = event.target.value
      if (value) {
        this.blurFn(value.length, 2, 70, '学校名称')
      }
    },
    majorNameBlur(event) {
      // let value = event.target.value.replace(/[^\x00-\xff]/g, 'AA');
      event.target.value = event.target.value.replace(/\n/g, '')
      let value = event.target.value
      if (value) {
        this.blurFn(value.length, 2, 30, '专业名称')
      }
      this.majorNameIsEdit = false
    },
    majorNameFocus() {
      this.majorNameIsEdit = true
    },
    emailBlur(event) {
      event.target.value = event.target.value.replace(/\n/g, '')
      let value = event.target.value
      if (value) {
        this.blurFn(value.length, 0, 50, '邮箱', event.target.value)
      }
      this.emailIsEdit = false
    },
    emailFocus() {
      this.emailIsEdit = true
    },
    blurFn(length, min, max, name, value) {
      if (name === '邮箱') {
        if (min <= length && length <= max) {
          if (length > 0) {
            const regMail = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
            if (!regMail.test(value)) {
              this.$notify({ type: 'warning', message: `请输入正确格式的邮箱`, duration: 2 * 1000 })
              // this.validTip('请输入正确格式的邮箱')
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        } else {
          this.$notify({
            type: 'warning',
            message: `邮箱请输入${max}个字符以内`,
            duration: 2 * 1000,
          })
          // this.validTip(`邮箱请输入${max}个字符以内`)
          return false
        }
      } else {
        if (min <= length && length <= max) {
          return true
        } else {
          this.$notify({
            type: 'warning',
            message: `${name}请输入${min}-${max}个字符`,
            duration: 2 * 1000,
          })
          // this.validTip(`${name}请输入${min}-${max}个字符`)
          return false
        }
      }
    },
    positionSchoolDate(type) {
      // 定位默认时间
      let birthday
      if (this.nineField.birthday) {
        let newDate = this.nineField.birthday.replace('-', '/')
        birthday = new Date(`${newDate}/1`)
      } else {
        birthday = new Date(this.currentDate)
      }
      let year = birthday.getFullYear()
      let startDate = new Date(birthday.setYear(year + this.defaultStart))
      if (this.nineField.startDate) {
        let newStartDate = this.nineField.startDate.replace('-', '/')
        startDate = new Date(`${newStartDate}/1`)
      }
      let startYear = startDate.getFullYear()
      if (type === 'start') {
        this.schoolDate = startDate
      } else {
        this.schoolDate = new Date(startDate.setYear(startYear + this.defaultEnd))
      }
    },
    confirmBirthday(val) {
      this.nineField.birthday = dateFormat(val)
      this.currentDate = val
      this.showBirthdayTimePopup = false
    },
    confirmEducation(val) {
      this.nineField.education = val.value
      this.nineField.eduLevel = val.numberKey
      this.educationShow = false
      // 设置在校开始时间:出生年份+defaultStart; 在校结束时间:开始时间+defaultEnd;
      switch (val.numberKey) {
        case 9: // 初中及以下
          this.defaultStart = 12
          this.defaultEnd = 3
          break
        case 7: // 高中
          this.defaultStart = 15
          this.defaultEnd = 3
          break
        case 12: // 中专/中技
          this.defaultStart = 15
          this.defaultEnd = 3
          break
        case 5: // 大专
          this.defaultStart = 18
          this.defaultEnd = 3
          break
        case 4: // 本科
          this.defaultStart = 18
          this.defaultEnd = 4
          break
        case 3: // 硕士
          this.defaultStart = 22
          this.defaultEnd = 3
          break
        case 10: // MBA/EMBA
          this.defaultStart = 25
          this.defaultEnd = 2
          break
        case 1: // 博士
          this.defaultStart = 25
          this.defaultEnd = 5
          break
        default:
          break
      }
    },
    selectDate(type) {
      if (type === 'start') {
        if (!this.nineField.startDate) {
          this.positionSchoolDate('start')
        } else {
          this.schoolDate = new Date(this.nineField.startDate)
        }
        this.schoolTimeType = 'start'
        this.schoolTimeTitle = '请选择开始时间'
      } else {
        if (!this.nineField.endDate) {
          this.positionSchoolDate('end')
        } else {
          this.schoolDate = new Date(this.nineField.endDate)
        }
        this.schoolTimeType = 'end'
        this.schoolTimeTitle = '请选择结束时间'
      }
      this.showSchoolTimePopup = true
    },
    confirmSchoolTime(val) {
      if (this.schoolTimeType === 'start') {
        this.nineField.startDate = dateFormat(val)
        this.showSchoolTimePopup = false
      } else if (this.schoolTimeType === 'end') {
        if (this.checkDate(this.nineField.startDate, val)) {
          this.nineField.endDate = dateFormat(val)
          this.showSchoolTimePopup = false
        }
      }
    },
    handleSchoolTimeCancel() {
      if (this.schoolTimeType === 'start') {
        this.showSchoolTimePopup = false
      } else if (this.schoolTimeType === 'end') {
        this.schoolTimeTitle = '请选择开始时间'
        this.schoolTimeType = 'start'
      }
    },
    cancelPopup() {
      this.cityShow = false
    },
    savePopup() {
      if (!this.activeId) {
        this.$notify({
          type: 'warning',
          message: '请选择右侧城市',
          duration: 2 * 1000,
        })
        // this.validTip('请选择右侧城市')
        return
      }
      let { id: cid, text: ctext, parentNumberKey } = this.currentCity
      let province = this.areaItems.filter(item => {
        if (item.id === cid) {
          return item
        } else {
          return item.children && item.children.filter(child => child.id === cid)[0]
        }
      })
      let provinceObj = province[0] || {}
      this.nineField.city = provinceObj.text == ctext ? ctext : `${ctext}`
      this.nineField.cityId = cid
      this.nineField.countryId = parentNumberKey === 0 ? cid : ''
      this.cityShow = false
      this.activeId = cid
    },
    cityChange(val) {
      this.currentCity = val
    },
    submit() {
      console.log(this.nineField)
      let keys = Object.keys(this.nineField)
      let flag = keys.every(ele => this.checkIpt(ele))
      this.validPlaceholder()
      if (
        flag &&
        this.checkDate(this.nineField.startDate, this.nineField.endDate) &&
        this.blurFn(this.nineField.name.length, 2, 20, '姓名') &&
        this.blurFn(this.nineField.schoolName.length, 2, 70, '学校名称') &&
        this.blurFn(this.nineField.majorName.length, 2, 30, '专业名称') &&
        this.blurFn(this.nineField.email.length, 0, 50, '邮箱', this.nineField.email)
      ) {
        const postData = {
          ...this.nineField,
          scene: this.$route.query.scene,
        }
        userSubmit(postData).then(res => {
          if (res && res.status == 200) {
            const data = res.data
            if (data.success) {
              if (data.data.hideStatus === 1) {
                // 1打开弹框，2不打开
                this.redirectUrl = data.data.redirectUrl
                this.noDisturbShow = true
              } else {
                this.waitOverlay(data.data.redirectUrl)
              }
            } else {
              this.$notify({
                type: 'warning',
                message: data.apiErrorMessage,
                duration: 3 * 1000,
              })
              // this.validTip(data.apiErrorMessage)
            }
          }
        })
      }
    },
    checkIpt(key) {
      if (key !== 'countryId') {
        if (
          this.nineField[key] == '' ||
          this.nineField[key] == null ||
          this.nineField[key] == undefined
        ) {
          this.$notify({
            type: 'warning',
            message: this.checkKey(key) + '不能为空',
            duration: 2 * 1000,
          })
          // this.validTip('请先填写相关信息')
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    checkIptNoTip(key) {
      if (key !== 'countryId') {
        if (
          this.nineField[key] == '' ||
          this.nineField[key] == null ||
          this.nineField[key] == undefined
        ) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    checkDate(start, end) {
      if (end) {
        if (new Date(start) > new Date(end)) {
          this.$notify({
            type: 'warning',
            message: '开始时间不能大于结束时间',
            duration: 3 * 1000,
          })
          // this.validTip('开始时间不能大于结束时间')
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    checkKey(key) {
      switch (key) {
        case 'name':
          return '姓名'

        case 'sexType':
          return '性别'

        case 'birthday':
          return '出生日期'

        case 'cityId':
          return '现居住城市'

        case 'eduLevel':
          return '最高学历'

        case 'schoolName':
          return '学校名称'

        case 'majorName':
          return '所学专业'

        case 'startDate':
          return '在校开始时间'

        case 'endDate':
          return '在校结束时间'

        case 'activityShareId':
          return 'activityShareId'

        case 'activityUserId':
          return 'activityUserId'

        case 'email':
          return '邮箱'

        default:
          break
      }
    },
    deleteKey(data) {
      if (data) {
        data.map(ele => {
          if (ele.children.length <= 0) {
            delete ele.children
          } else {
            this.deleteKey(ele.children)
          }
        })
      }
    },
    async loadProvinceList() {
      let data = await getProvinceList()
      if (data.status === 200) {
        let datas = data.data
        let areaList = datas.map(item => {
          let childrens = null
          if (!item.children || (item.children && item.children.length == 0)) {
            childrens = [
              { id: item.numberKey, text: item.value, parentNumberKey: item.parentNumberKey },
            ]
          } else {
            childrens = item.children.map(child => {
              return {
                id: child.numberKey,
                text: child.value,
                parentNumberKey: child.parentNumberKey,
              }
            })
          }
          return {
            id: item.numberKey,
            text: item.value,
            children: childrens,
            parentNumberKey: item.parentNumberKey,
          }
        })
        const overseasIndex = areaList.findIndex(item => {
          return item.parentNumberKey === 0
        })
        const overseas = areaList.find(item => {
          return item.parentNumberKey === 0
        })
        areaList.splice(overseasIndex, 1)
        areaList.unshift(overseas)
        this.areaItems = areaList
      }
    },
    async loadEducation() {
      let data = await getEducation()
      if (data.status === 200) {
        this.educationData = data.data.map(item => {
          return item
        })
      }
    },
    async userOpen() {
      const data = {
        activityShareId: this.$route.query.activityShareId,
        isNew: this.$route.query.isNew || 0,
        scene: this.$route.query.scene,
      }
      if (this.$route.query.activityShareId === '-1') {
        // 自然流量
        data.activityId = this.$route.query.activityId
      }
      const res = await userOpen(data)
      if (res && res.status == 200) {
        if (res.data.errorCode === 420) {
          this.$router.push({
            name: 'Offline',
          })
        }
        const data = res.data.data
        document.title = data.title ? data.title : '海外活动'
        document.getElementsByTagName('title')[0].innerText = data.title ? data.title : '海外活动'
        this.bannerUrl = data.bannerUrl
        this.activityId = data.activityId
        if (data.redirectUrl) {
          // 判断有无简历
          this.waitOverlay(data.redirectUrl, 'success')
        } else {
          this.showFlag = true
          this.showEmailField = data.showEmailField
          this.nineField = data
          delete this.nineField.redirectUrl
          delete this.nineField.bannerUrl
          if (data.cityId) {
            // this.activeId = data.cityId
            this.areaItems.forEach((ele, index) => {
              ele.children.forEach(e => {
                if (e.id == data.cityId) {
                  this.nineField.city = e.text
                  this.nineField.countryId = e.parentNumberKey === 0 ? e.id : ''
                  this.activeIndex = index
                }
              })
            })
          }
          if (data.eduLevel) {
            this.currentEducationIndex = this.educationData.findIndex(item => {
              return item.numberKey === data.eduLevel
            })
            this.$set(
              this.nineField,
              'education',
              this.educationData[this.currentEducationIndex].value,
            )
          }
          if (data.birthday) {
            let newDate = data.birthday.replace('-', '/')
            this.currentDate = new Date(`${newDate}/1`)
          }
        }
      }
    },
    handleRefuse() {
      hideUserResume({ activityId: this.activityId }).then(res => {
        if (res && res.status == 200) {
          const data = res.data
          if (data.success) {
            this.waitOverlay(this.redirectUrl)
          } else {
            this.$notify({
              type: 'warning',
              message: data.apiErrorMessage,
              duration: 3 * 1000,
            })
          }
        }
      })
    },
    handleAllow() {
      this.waitOverlay(this.redirectUrl)
    },
    confirmSchoolName() {
      this.nineField.schoolName = this.schoolName
      this.isShowSchoolList = false
    },
    handleSelectSchool() {
      this.schoolName = this.nineField.schoolName
      this.searchSchoolList(this.schoolName)
      this.searchSchoolText = this.schoolName
      this.isShowSchoolList = true
    },
    validTip(tip) {
      this.overlayTip = tip
      this.showOverlayTip = true
      let timer = setTimeout(() => {
        this.showOverlayTip = false
        clearTimeout(timer)
      }, 1500)
    },
    validPlaceholder() {
      const validField = [
        'name',
        'sexType',
        'birthday',
        'cityId',
        'education',
        'eduLevel',
        'schoolName',
        'majorName',
        'startDate',
        'endDate',
        'email',
      ]
      validField.forEach(item => {
        if (!this.nineField[item]) {
          this.error[item] = true
        } else {
          this.error[item] = false
        }
      })
    },
    selectSexType(type) {
      this.error.sexType = false
      this.nineField.sexType = type
    },
  },
}
</script>

<style lang="less" scoped src="./nineFieldOverseas.less"></style>
